<template>
  <div class="contract-all-manage" ref="contractAllManage">
    <div class="app-search-controls">
      <div class="wrap">
        <p>客户信息</p>
        <el-input placeholder="请输入客户姓名或手机号" v-model="search.valueOne"></el-input>
      </div>
      <div class="wrap">
        <p>渠道信息</p>
        <el-input placeholder="请输入渠道公司名称或经纪人姓名" v-model="search.valueTwo"></el-input>
      </div>
      <div class="wrap">
        <p>签约房间</p>
        <el-input placeholder="请输入签约房间信息" v-model="search.valueThree"></el-input>
      </div>
      <div class="wrap">
        <p>置业顾问</p>
        <el-input placeholder="请输入职业顾问姓名" v-model="search.valueFour"></el-input>
      </div>
      <div class="wrap">
        <p>首次抓拍时间</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodOne" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
      <div class="wrap">
        <p>报备时间</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodTwo" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
      <div class="wrap">
        <p>签约时间</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodThree" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
      <div class="wrap">
        <p>导入时间</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodFour" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
      <div class="wrap">
        <p>风险判定</p>
        <el-select v-model="search.selectValueOne" placeholder="请选择" clearable>
          <el-option v-for="(value, index) in selectOneOptions" :key="index" :label="value.text" :value="value.value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>风险状态</p>
        <el-select v-model="search.selectValueTwo" placeholder="请选择" clearable>
          <el-option v-for="(value, index) in selectTwoOptions" :key="index" :label="value.text" :value="value.value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>签约项目</p>
        <el-select v-model="search.selectValueThree" placeholder="请选择" clearable>
          <el-option v-for="(value, index) in selectThreeOptions" :key="index" :label="value.project_attr_name" :value="value.project_id"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>网批状态</p>
        <el-select v-model="search.selectValueFour" placeholder="请选择" clearable>
          <el-option v-for="(value, index) in selectFourOptions" :key="index" :label="value.text" :value="value.value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>风险类型</p>
        <el-select multiple collapse-tags v-model="search.selectValueFive" placeholder="请选择" clearable>
          <el-option v-for="(value, index) in selectFiveOptions" :key="index" :label="value.text" :value="value.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="app-control app-table-control">
      <el-button type="primary" @click="searchParams">搜索</el-button>
      <el-button @click="resetParams">重置</el-button>
      <el-button type="text" v-if="searchStatus" @click="searchStatus = false">收起<i class="el-icon-arrow-up"></i></el-button>
      <el-button type="text" v-else @click="searchStatus = true">展开<i class="el-icon-arrow-down"></i></el-button>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="签约项目" prop="project_name"></el-table-column>
      <el-table-column label="客户信息">
        <template slot-scope="{row}">
          <p>{{row.customer_name}}</p>
          <el-popover trigger="hover" v-if="row.mingyuan_update_data_times > 0">
            <el-tag size="mini" effect="plain" slot="reference">更新</el-tag>
            <div class="time-items">
              <p v-for="value in row.mingyuan_update_data_history_datetime" :key="value">{{value}}</p>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="签约房间" prop="project_chamber_name"></el-table-column>
      <el-table-column label="渠道信息">
        <template slot-scope="{row}">
          <p>{{row.realtor_name}}</p>
          <p>{{row.realtor_company_name}}</p>
          <p>{{row.realtor_role}}</p>
        </template>
      </el-table-column>
      <el-table-column label="置业顾问" prop="user_name"></el-table-column>
      <el-table-column label="签约时间" prop="contract_datetime"></el-table-column>
      <el-table-column label="风险判定">
        <template slot-scope="{row}">
          <p v-if="!row.risk_signing_status" class="risk-item">
            <span>系统判定</span>
            <el-tag size="small" type="info">分析中</el-tag>
          </p>
          <p v-if="row.risk_signing_status" class="risk-item">
            <span>系统判定</span>
            <el-tag size="small" type="success" v-if="row.risk_signing_status === 1">正常</el-tag>
            <el-tag size="small" type="warning" v-if="row.risk_signing_status === 1 && row.has_second_analysis_status === 1">后补</el-tag>
            <el-tag size="small" type="danger" v-if="row.risk_signing_status === 2">风险</el-tag>
          </p>
          <p v-if="row.handle_status" class="risk-item">
            <span>初审判定</span>
            <el-tag size="small" type="success" v-if="row.handle_result_state === 1">正常</el-tag>
            <el-tag size="small" type="danger" v-if="row.handle_result_state === 2">风险</el-tag>
          </p>
          <p v-if="row.second_handle_status" class="risk-item">
            <span>复审判定</span>
            <el-tag size="small" type="success" v-if="row.second_handle_result_state === 1">正常</el-tag>
            <el-tag size="small" type="danger" v-if="row.second_handle_result_state === 2">风险</el-tag>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="风险状态" prop="status"></el-table-column>
      <el-table-column label="网批状态">
        <template slot-scope="{row}">
          <el-button type="text" v-if="row.pd_net_batch_status === 1" @click="startTask(row.customer_transaction_history_id)">开始网批</el-button>
          <p v-else-if="row.pd_net_batch_status === 2">等待网批</p>
          <p v-else-if="row.pd_net_batch_status === 3">风控流程中</p>
          <p v-else-if="row.pd_net_batch_status === 4" class="status-item"><span>网批流程中</span><span>网批ID：{{row.pd_net_batch_no}}</span></p>
          <p v-else-if="row.pd_net_batch_status === 5" class="status-item"><span>网批结束</span><span>网批ID：{{row.pd_net_batch_no}}</span></p>
          <p v-else-if="row.pd_net_batch_status === 6">网批驳回</p>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="info(row.customer_transaction_history_id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center append-to-body size="85%">
      <contract-info :id="dialog.id" v-if="dialog.show"></contract-info>
    </el-drawer>
  </div>
</template>

<script>
  import ContractService from '@/io/contract.js';
  import ContractInfo from '@/views/ContractInfo.vue';

  export default {
    name: 'ContractAllManage',
    data() {
      return {
        dialog: {
          title: '签约详情',
          show: false,
          id: null
        },
        searchStatus: false,
        search: {
          valueOne: '',
          valueTwo: '',
          valueThree: '',
          valueFour: '',
          periodOne: [],
          periodTwo: [],
          periodThree: [],
          periodFour: [],
          selectValueOne: '',
          selectValueTwo: '',
          selectValueThree: '',
          selectValueFour: '',
          selectValueFive: []
        },
        selectOneOptions: [],
        selectTwoOptions: [],
        selectThreeOptions: [],
        selectFourOptions: [],
        selectFiveOptions: [],
        options: {},
        datas: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        loading: false
      }
    },
    components: {
      ContractInfo,
    },
    watch: {
      searchStatus: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            this.switchSearchRegion(document.querySelectorAll('.app-search-controls .wrap'), newValue);
          });
        },
        immediate: true
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$refs.contractAllManage) {
          this.initOptions().then(() => {
            this.initPage();
          }).catch(() => {});
        }
      });
    },
    methods: {
      startTask(id) {
        this.$confirm(
          '确认开始网批流程?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ContractService.task(id);
        }).then(res => {
          return this.initPage();
        }).catch(() => {});
      },
      info(id) {
        this.dialog.show = true;
        this.dialog.id = id;
      },
      initOptions() {
        return ContractService.searchParam().then(res => {
          this.selectOneOptions = res.data.handle_result_state;
          this.selectTwoOptions = res.data.handle_status;
          this.selectThreeOptions = res.data.project_list.data;
          this.selectFourOptions = res.data.pd_net_status;
          this.selectFiveOptions = res.data.risk_signing_type;
          this.options = res.data;
        }).catch(() => {});
      },
      initPage() {
        this.loading = true;
        ContractService.allListPage(
          this.search.valueOne,
          this.search.valueTwo,
          this.search.valueThree,
          this.search.valueFour,
          this.search.periodOne ? this.search.periodOne[0] : '',
          this.search.periodOne ? this.search.periodOne[1] : '',
          this.search.periodTwo ? this.search.periodTwo[0] : '',
          this.search.periodTwo ? this.search.periodTwo[1] : '',
          this.search.periodThree ? this.search.periodThree[0] : '',
          this.search.periodThree ? this.search.periodThree[1] : '',
          this.search.periodFour ? this.search.periodFour[0] : '',
          this.search.periodFour ? this.search.periodFour[1] : '',
          this.search.selectValueOne,
          this.search.selectValueTwo,
          this.search.selectValueThree,
          this.search.selectValueFour,
          this.search.selectValueFive.join(','),
          this.page.currentPage
        ).then(res => {
          this.datas = res.data.data.map(val => {
            let status = {
              1: '正常',
              2: '待处理',
              3: '待复审',
              4: '已复审'
            }
            val.status = status[val.customer_transaction_history_handle_state];
            this.options.realtor_roles.forEach(m => {
              if (m.value === val.realtor_role) {
                val.realtor_role = m.text;
              }
            });
            val.contract_datetime = val.contract_datetime.split(' ')[0];
            return val;
          });
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initPage();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initPage();
      },
      resetParams() {
        this.search = {
          valueOne: '',
          valueTwo: '',
          valueThree: '',
          valueFour: '',
          periodOne: [],
          periodTwo: [],
          periodThree: [],
          periodFour: [],
          selectValueOne: '',
          selectValueTwo: '',
          selectValueThree: '',
          selectValueFour: '',
          selectValueFive: []
        };
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>
  .contract-all-manage {
    .risk-item {
      margin: 5px 0;
      display: flex;
      align-items: center;
      .el-tag {
        margin-left: 5px;
      }
    }
    .status-item {
      display: flex;
      flex-direction: column;
    }
  }
  .time-items {
    p {
      text-align: center;
      &:not(:last-of-type) {
        margin-bottom: 5px;
      }
    }
  }
</style>